import { render, staticRenderFns } from "./MaterialTable.vue?vue&type=template&id=acb35758&scoped=true"
import script from "./MaterialTable.vue?vue&type=script&lang=js"
export * from "./MaterialTable.vue?vue&type=script&lang=js"
import style0 from "./MaterialTable.vue?vue&type=style&index=0&id=acb35758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb35758",
  null
  
)

export default component.exports